import type { ComponentType } from "react";
import { useNavigate, useParams } from "react-router";
import type { IconName } from "@/components/common/Icon";
import { NavItemButton } from "@/components/common/NavItemButton";
import { TOP_GAP } from "@/lib/pane-styles";
import { MAIN_VIEW_PATHS } from "@/stores/useLayoutStore";
import { AuthenticationTab } from "./AuthenticationTab";
import { IpAllowlistTab } from "./IpAllowlistTab";
import { UsersTab } from "./UsersTab";

type OrganizationTab = "users" | "ip-allowlist" | "authentication";

const TABS: { id: OrganizationTab; icon: IconName; label: string }[] = [
	{ id: "users", icon: "user", label: "ユーザー" },
	{ id: "ip-allowlist", icon: "earth", label: "IP 制限" },
	{ id: "authentication", icon: "key", label: "認証" },
];

const TAB_CONTENT: Record<OrganizationTab, ComponentType> = {
	users: () => <UsersTab scope="own" />,
	"ip-allowlist": IpAllowlistTab,
	authentication: AuthenticationTab,
};

/** サイドバーの「組織」のメインビュー。左のナビでユーザー・IP 制限・認証を切り替える。 */
export function OrganizationPage() {
	const navigate = useNavigate();
	const { tab: tabParam } = useParams<{ tab: string }>();
	const activeTab = TABS.find((tab) => tab.id === tabParam)?.id ?? TABS[0].id;
	const ActiveContent = TAB_CONTENT[activeTab];

	return (
		<div
			data-testid="organization-page"
			style={{ display: "flex", height: "100%", background: "var(--surface-1)" }}
		>
			<nav
				style={{
					flex: "none",
					width: 168,
					display: "flex",
					flexDirection: "column",
					gap: 4,
					padding: `${TOP_GAP + 8}px 8px 8px`,
					borderRight: "var(--pane-header-border)",
				}}
			>
				{TABS.map((tab) => (
					<NavItemButton
						key={tab.id}
						icon={tab.icon}
						label={tab.label}
						compact
						selected={activeTab === tab.id}
						onClick={() => navigate(`${MAIN_VIEW_PATHS.organization}/${tab.id}`, { replace: true })}
						testId={`organization-tab-${tab.id}`}
					/>
				))}
			</nav>
			<div style={{ flex: 1, minWidth: 0 }}>
				<ActiveContent />
			</div>
		</div>
	);
}
